export const START_CHAT_REQUEST = 'START_CHAT_REQUEST';
export const START_CHAT_SUCCESS = 'START_CHAT_SUCCESS';
export const START_CHAT_ERROR = 'START_CHAT_ERROR';
export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';
export const STOP_CHAT_REQUEST = 'STOP_CHAT_REQUEST';
export const RESTART_CHAT = 'RESTART_CHAT';
export const TOGGLE_MINIMIZE_CHAT_REQUEST = 'TOGGLE_MINIMIZE_CHAT_REQUEST';
export const SAVE_USER_RESPONSE = 'SAVE_USER_RESPONSE';
export const SAVE_BOT_RESPONSE = 'SAVE_BOT_RESPONSE';
